/** @jsx React.DOM */

var React = require("react/addons");

var Loader = React.createClass({displayName: 'Loader',
  getInitialState: function() {
    return { frame: 0 };
  },

  componentDidMount: function() {
    this.tick();
  },

  tick: function() {
    var frame = this.state.frame;
    var newFrame = frame > 7 ? 1 : frame + 1;
    this.setState({ frame: newFrame });
    this.setState({ timer: setTimeout(this.tick, 300) });
  },

  render: function() {
    return React.DOM.div({className: "fuelux"}, 
      React.DOM.div({className: "loader", 'data-initialize': "loader", 'data-frame': this.state.frame})
    );
  },

  componentWillUnmount: function() {
    clearTimeout(this.state.timer);
  }
});

module.exports = Loader;



/*****************
 ** WEBPACK FOOTER
 ** ./src/editor/components/common/Loader.js
 ** module id = 33
 ** module chunks = 0
 **/